var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.03003V2.05003V4.05003C17.39 4.59003 20.5 8.58003 19.96 12.97C19.5 16.61 16.64 19.5 13 19.93V21.93C18.5 21.38 22.5001 16.5 21.9501 11C21.5001 6.25003 17.73 2.50003 13 2.03003ZM11 2.06003C9.05005 2.25003 7.19005 3.00003 5.67005 4.26003L7.10005 5.74003C8.22005 4.84003 9.57005 4.26003 11 4.06003V2.06003ZM4.26005 5.67003C3.00005 7.19003 2.25005 9.04003 2.05005 11H4.05005C4.24005 9.58003 4.80005 8.23003 5.69005 7.10003L4.26005 5.67003ZM15.5 8.50003L10.62 13.38L8.50005 11.26L7.44005 12.32L10.62 15.5L16.56 9.56003L15.5 8.50003ZM2.06005 13C2.26005 14.96 3.03005 16.81 4.27005 18.33L5.69005 16.9C4.81005 15.77 4.24005 14.42 4.06005 13H2.06005ZM7.10005 18.37L5.67005 19.74C7.18005 21 9.04005 21.79 11 22V20C9.58005 19.82 8.23005 19.25 7.10005 18.37Z",
    fill: "#78D64B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in_progress.d5c9e5dd71581b243158a258d77c0901.svg";
export { ForwardRef as ReactComponent };